module.exports = __webpack_public_path__ + "img/3.ed9a58a8.png";